module.exports = __webpack_public_path__ + "static/media/Bahana FM.c1e51573.png";